<div class="modal-header" [class.error]="error" [class.success]="!error">
  <i class="fal fa-info-circle" *ngIf="!error"></i>
  <i class="fal fa-exclamation-circle" *ngIf="error"></i>
  <h4 class="modal-title">{{(error ? "modal.warning" : "modal.information") | translate}}</h4>
  <button type="button" class="close" aria-label="Close" mat-dialog-close>
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="scroll">
    <ng-container *ngIf="stats && !stats?.isAccepted">
      <div class="section">
        <ng-container *ngIf="stats?.recordsToUpdate === 0">
          <span>{{'fuelCard.fileCorrect' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="stats?.recordsToUpdate > 0">
          <span>{{'fuelCard.fileCorrectWithDuplicatedEvents' | translate }}</span>
          <span class="red-text">{{'fuelCard.overwriteEvent' | translate }}</span>
        </ng-container>

      </div>
      <div class="d-flex justify-content-center mb-2">
        <button type="button" class="btn button-secondary-important me-3" (click)="accept()">
          {{ 'fuelCard.accept' | translate }}
        </button>
        <button type="button" class="btn button-primary" (click)="activeModal.close()">
          {{ 'fuelCard.cancel' | translate }}
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="stats && stats?.isAccepted">
      <div class="section">
        <span>{{'fuelCard.importedRefuelingEvents' | translate }}: {{stats?.filteredFuelingsCount}}</span>
        <span>{{'fuelCard.RefuelingEventsRequiringEditing' | translate }}: <span
          class="yellow-text">{{stats?.filteredFuelingsMatchedToUnitsCount}}</span></span>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-link" (click)="activeModal.close()">
          {{ 'ok' | translate }}
        </button>
      </div>
    </ng-container>
    <ng-container *ngIf="error">
      <div class="section">
        <pre>{{error?.errorMessage}}</pre>
      </div>
    </ng-container>
  </div>
</div>
